import { useFormatter, useTranslations } from "next-intl";
import Image from "next/image";
import { Button, Link, Stack, Text } from "@leabankab/component-library";
import { Heading } from "@/components/ui";

const CREDIT_LIMIT = 20000;

export const CardUpsell = ({ show }: { show: boolean }) => {
	const t = useTranslations("pages.ApprovedPage");
	const format = useFormatter();
	if (!show) return null;

	const creditLimit = format.number(CREDIT_LIMIT, {
		style: "currency",
		currency: "SEK",
		maximumFractionDigits: 0,
	});

	return (
		<div className="flex flex-col gap-2 rounded-xl bg-bg-accent p-3">
			<Heading
				level={2}
				textStyle="heading-md"
				color="primary.base"
				fontWeight="semibold"
				className="uppercase"
			>
				{t("common.creditCardUpsell.header")}
			</Heading>
			<Stack className="gap-1.5 sm:gap-2">
				<Image
					alt="Credit card"
					height={164}
					src="/creditcard.png"
					width={260}
					sizes="(max-width: 600px) 85vw, 260px"
					style={{ width: "min(85vw, 260px)", height: "auto" }}
				/>
				<Text textStyle="body-sm">
					{t("common.creditCardUpsell.text1", { creditLimit })}
				</Text>
				<Text textStyle="body-sm">
					<Link href="https://leabank.se/lan/kreditkort">
						{t("common.creditCardUpsell.linkLabel")}
					</Link>
				</Text>
				<Button render={<a href="https://leabank.se/lan/kreditkort" />}>
					{t("common.creditCardUpsell.activateButton")}
				</Button>
			</Stack>
		</div>
	);
};
